<div fxLayout="column" fxFlex>
  <vdw-header
    [title]="'GENERAL.ACTIONS.EDIT_OBJECT' | bmsTranslate: {object: 'MACHINE.DETAILS.CREEL_MAPPING.TITLE' | bmsTranslate | lowercase}"
    svgIcon="creels-blue"
    [canShowClose]="true"
    (closeEvent)="close()"
  ></vdw-header>
  <article fxLayout="row" fxFlex="1 0 calc(100% - 144px)">
    <div class="sidebar-content" fxLayout="column" fxLayoutGap="24px" fxFlex>
      <app-colored-yarn-set-map-card
        *ngFor="let coloredYarnSetWithStartDent of creel.coloredYarnSetsWithStartDent; let coloredYarnSetIndex = index"
        [coloredYarnSetWithStartDent]="coloredYarnSetWithStartDent"
        [(activeColoredYarnSetCreelMap)]="creel.mappingForCurrentPositionOnMachine[coloredYarnSetIndex]"
      ></app-colored-yarn-set-map-card>
    </div>
  </article>
  <footer class="sidebar-footer" fxFlex="0 0 72px" fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="center center">
    <button mat-stroked-button (click)="close()">
      {{ 'GENERAL.ACTIONS.CANCEL' | bmsTranslate }}
    </button>
    <button mat-flat-button color="primary" (click)="save()">
      {{ 'GENERAL.ACTIONS.SAVE' | bmsTranslate }}
    </button>
  </footer>
</div>
